import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import FeaturedProjects from './components/FeaturedProjects';
import AllProjects from './components/AllProjects';
import TechnicalExpertise from './components/TechnicalExpertise';
import Contact from './components/Contact';
import Footer from './components/Footer';
import portfolioData from './data/portfolio.json';

function App() {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(portfolioData);
  }, []);

  if (!data) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="App">
      <Header data={data} />
      <main>
        <Hero data={data} />
        <About data={data} />
        <FeaturedProjects data={data} />
        <TechnicalExpertise data={data} />
        <AllProjects data={data} />
        <Contact data={data} />
      </main>
      <Footer data={data} />
    </div>
  );
}

export default App;
